import { gql } from '@apollo/client';

export const DELETE_INDICATOR = gql`
  mutation deleteIndicator($id: ID!) {
    deleteIndicator(id: $id) {
      id
    }
  }
`;
